/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";
import { SessionWalletCreateResponseCardsDataType } from "./SessionWalletCreateResponseCardsDataType";
import { Field } from "./Field";
import { SessionWalletCreateResponseApmDataType } from "./SessionWalletCreateResponseApmDataType";

/**
 * Session wallet create response data
 */

/**
 * Session data returned by `createSessionWallet` operation in case of a credit card session
 */

// required attributes
const SessionWalletCreateResponseData1R = t.interface({
  paymentMethodType: SessionWalletCreateResponseCardsDataType,

  cardFormFields: t.readonlyArray(Field, "array of Field")
});

// optional attributes
const SessionWalletCreateResponseData1O = t.partial({});

export const SessionWalletCreateResponseData1 = t.intersection(
  [SessionWalletCreateResponseData1R, SessionWalletCreateResponseData1O],
  "SessionWalletCreateResponseData1"
);

export type SessionWalletCreateResponseData1 = t.TypeOf<
  typeof SessionWalletCreateResponseData1
>;

/**
 * Session data returned by `createSessionWallet` operation in case of a credit card session
 */

// required attributes
const SessionWalletCreateResponseData2R = t.interface({});

// optional attributes
const SessionWalletCreateResponseData2O = t.partial({
  paymentMethodType: SessionWalletCreateResponseApmDataType,

  redirectUrl: t.string
});

export const SessionWalletCreateResponseData2 = t.intersection(
  [SessionWalletCreateResponseData2R, SessionWalletCreateResponseData2O],
  "SessionWalletCreateResponseData2"
);

export type SessionWalletCreateResponseData2 = t.TypeOf<
  typeof SessionWalletCreateResponseData2
>;

export const SessionWalletCreateResponseData = t.union(
  [SessionWalletCreateResponseData1, SessionWalletCreateResponseData2],
  "SessionWalletCreateResponseData"
);

export type SessionWalletCreateResponseData = t.TypeOf<
  typeof SessionWalletCreateResponseData
>;
